import React, { FC, useCallback, useEffect, useState } from 'react';
import { Image, ScrollView, View } from 'react-native';
import { Text } from '../../../components/Text/Text';
import { COLORS, FONTS } from '../../../constants';
import { INotice } from '../../../types/notices.types';
import { NoticesApi } from '../../../services/api';
import { IS_WEB } from '../../../constants/platform';
import TextTicker from 'react-native-text-ticker';
import { NavigationService } from '../../../services/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import ChatRoomApi from '../../../services/api/chatroom.api';
import { setUnreadMessage } from '../../../services/redux/reducers/AuthSlice';
import { setHeaderConfigAxios } from '../../../services/api/axios';
import { IChatRoom } from '../../../types/chat.types';
import { htmlDecode } from '../../../services/utils/htmlDecode';

export const Notices: FC = () => {
  const dispatch = useDispatch();
  const [notice, setNotice] = useState<INotice>();
  const [lastChatRoom, setLastChatRoom] = useState<IChatRoom>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { unreadMessage, loggedin, access_token } = useSelector(
    (redux: RootState) => redux.authReducer
  );

  const getUnreadMessage = useCallback(async () => {
    ChatRoomApi.getUnreadMessage().then((res) => {
      dispatch(setUnreadMessage(res.data.data.unread_messages));
    });
  }, [dispatch]);

  const getLastChatroom = useCallback(async () => {
    setIsLoading(true);
    ChatRoomApi.getChatRoom()
      .then((res) => {
        const chatrooms = res.data.data.data;
        if (chatrooms && chatrooms.length > 0) {
          setLastChatRoom(chatrooms[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    getLastChatroom();
    if (loggedin) {
      setHeaderConfigAxios(access_token);
      getUnreadMessage();
    }
  }, [getLastChatroom, getUnreadMessage, access_token, loggedin]);

  return (
    <>
      {!isLoading && lastChatRoom && unreadMessage && unreadMessage > 0 ? (
        <View>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 20,
            }}
          >
            <View style={{ position: 'relative' }}>
              <Image
                source={require('../../../assets/notice-icon.png')}
                style={{
                  width: 25,
                  height: 25,
                  marginRight: 10,
                  resizeMode: 'contain',
                }}
              />
              {unreadMessage && unreadMessage > 0 ? (
                <View
                  style={{
                    width: 20,
                    height: 20,
                    backgroundColor: COLORS.RED_PRIMARY,
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 20,
                    position: 'absolute',
                    right: 0,
                    top: -8,
                  }}
                >
                  <Text
                    style={{
                      color: COLORS.WHITE,
                      fontFamily: FONTS.AvenirMedium,
                      fontSize: 12,
                    }}
                  >
                    {unreadMessage}
                  </Text>
                </View>
              ) : (
                <></>
              )}
            </View>
            {IS_WEB ? (
              <ScrollView
                horizontal={true}
                showsHorizontalScrollIndicator={false}
              >
                <Text
                  style={{
                    fontFamily: FONTS.AvenirMedium,
                    fontSize: 16,
                    color: COLORS.BLACK,
                    flex: 1,
                  }}
                  numberOfLines={1}
                  onPress={() => {
                    NavigationService.push('MessagesUser', {
                      id: lastChatRoom.id,
                    });
                  }}
                >
                  {htmlDecode(lastChatRoom.last_message?.content)}
                </Text>
              </ScrollView>
            ) : (
              <>
                {/* Disable on website */}
                {/* <TextTicker
                  style={{
                    fontFamily: FONTS.AvenirMedium,
                    fontSize: 20,
                    color: COLORS.BLACK,
                    flex: 1,
                  }}
                  duration={3000}
                  loop={true}
                  repeatSpacer={50}
                  bounce={false}
                  marqueeDelay={1000}
                  scrollSpeed={50}
                  onPress={() => {
                    NavigationService.push('MessagesUser', {
                      id: lastChatRoom.id,
                    });
                  }}
                >
                  {htmlDecode(lastChatRoom.last_message?.content)}
                </TextTicker> */}
              </>
            )}
          </View>
        </View>
      ) : (
        <></>
      )}
    </>
  );
};
